<hsg-modal>
  <span class="title">רישום למידע אישי</span>
  <div [gaManager]="{type:'impression',category:this.gaCategory,action:'Registration Details Screen Presented',label:'Process Name = '+this.getCurrentProcess(data?.CurrentProcess)}"
    ngForm #activationForm="ngForm" (ngSubmit)="submit(activationForm)" (keyup.enter)="activationForm.onSubmit()" class="body">
    <div class="h-gr h-gr--column">
      <div class="h-cl">
        <p>
          שדות בטופס המסומנים בכוכבית הינם שדות חובה
         <span class="asterix">*</span>
          </p>    
        <hsg-field>
          <input type="email" name="email" hsgInput [ngModel]="data?.existingMail" [equelValueValidator]="emailValidate" aria-invalid="false"
          required 
          pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,63}$"
            #email="ngModel">
          <label hsgLabel>הזן כתובת דואר אלקטרוני</label>
          <div hsgError *ngIf="email?.invalid && activationForm.submitted" class="h-hero__formDanger">
            <div hsgError *ngIf="email?.errors?.required">
              עליך להזין אימייל
            </div>
            <div hsgError *ngIf="email?.errors?.pattern">
              כתובת דואר אלקטרוני אינה תקינה
            </div>
          </div>
        </hsg-field>
      </div>
      <div class="h-cl">
        <hsg-field>
          <input type="email" name="confirmEmail" hsgInput ngModel [equelValueValidator]="email"  aria-invalid="false"
           required #emailValidate="ngModel">
          <label hsgLabel>הזן שנית כתובת דואר אלקטרוני</label>
          <div hsgError *ngIf="emailValidate?.invalid && activationForm.submitted" class="h-hero__formDanger">
            <div hsgError *ngIf="emailValidate?.errors?.required">
              עליך להזין שנית אימייל
            </div>
            <div hsgError *ngIf="emailValidate?.errors?.equelValue && emailValidate?.value ">
              אין התאמה בין האימיילים שנבחרו
            </div>
          </div>
        </hsg-field>
      </div>
      <div class="h-cl u-mt-xxl">
        <div class="h-panel h-panel--primary c-remarks">
          <p>
              ההרשמה למידע האישי באתר האינטרנט של הראל השקעות בביטוח ושירותים פיננסים בע"מ ו/או בכל אחת מהחברות הבנות והחברות הקשורות שלה ("קבוצת הראל") לצורך קבלת שירותים ומידע אודות מוצרי הביטוח, החיסכון ארוך הטווח והפיננסיים שלך בקבוצת הראל ("המוצרים") וכן לצורך ביצוע פעולות באמצעות אתר האינטרנט ("השירות") תעשה בכפוף לתנאים הבאים: 
          </p>

          <p>
           1. הראל לא תישא בשום אחריות בגין נזק, הפסד או אובדן כלשהו, העלולים להיגרם במישרין או בעקיפין, כתוצאה ממתן השירותים, עיכוב במתן השירותים או הפסקתם או כתוצאה מהשמטה, שיבוש, פגם, הפרעה, מחיקה, כשל, שגיאה במידע או בנתונים, או כתוצאה מתקלות בציוד המשתמש, או בציוד של הראל או כתוצאה מגורמים ו/או תקלות שאינם בשליטת הראל. כמו כן, הראל לא תהיה אחראית לכל נזק, הפסד או אובדן כתוצאה מגניבה, השמדה, קיום גישה בלתי חוקית לכל מידע המצוי באתר ובגין כל התנהגות בלתי חוקית של משתמשים אחרים או צדדים שלישיים. זאת, כל עוד נוקטת הראל באמצעי אבטחה סבירים. 
          </p>
          <p>
              2. לא חלה עליך חובה חוקית למסור את המידע, שתמסור באתר, אך בלי מידע לא נוכל לספק לך שירות. המידע שתמסור ישמש את החברות בקבוצת הראל ו/או מי מטעמן על מנת לספק לך שירותים, וכן לשימושים נוספים הנלווים לשימושים האמורים לעיל ונדרשים לשם השלמתם, ולמטרות לגיטימיות אחרות, זאת אף באמצעות העברתו של המידע לצדדים שלישיים הפועלים בשמה ומטעמה של קבוצת הראל. 
          </p>
         <p>
            3. לתשומת ליבך, עדכניות המידע במסגרת השירות באתר זה תהיה בהתאם לעדכניות המידע הרשום במערכות החברה, נכון למועד עדכונו האחרון. בכל מקרה של סתירה בין מידע שפורסם באתר לבין מידע המצוי במערכות הראל, יהיה המידע המצוי במערכות הראל המידע המחייב. 
         </p>
         <p>
           <strong>השימוש באתר</strong>
         </p>
         <p>
            4. הסיסמא שתינתן לך לצורך רישיון הגישה לאתר ולשירות תינתן לצורך שימושך האישי בלבד ואין להעבירה לכל גורם אחר ללא הרשאה בכתב ומראש של הראל. 
         </p>
         <p>
            5. עליך לנקוט בכל האמצעים לשמירת הסיסמא בסוד ולא להעבירה לידי גורם בלתי מורשה. אין למכור ו/או להפיץ ו/או להעביר ו/או להשכיר את רישיון הגישה שלך לצד שלישי כלשהו ולעשות בו כל שימוש מעבר לתנאי ההרשאה שקיבלת מהראל. הראל לא תישא בנזק אשר עלול להיגרם כתוצאה מהעברת הסיסמא לידי גורם בלתי מורשה. 
         </p>
         <p>
            6. השימוש באתר מותר אך ורק למטרות חוקיות ולמטרות אשר לשמן נועד האתר. כל שימוש ו/או ניסיון לשימוש בסיסמא כוזבת, התחזות לאחר או חדירה בכל דרך שהיא למידע ו/או לנתונים אודות צד ג' כלשהו אסורים בהחלט. 
         </p>
         <p>
            7. משתמשים מתחת לגיל שמונה עשרה (18) וחוסים אינם רשאים להשתמש באתר בעצמם. על האפוטרופוס החוקי (למשל, הורה) להשתמש באתר בעבורם. למידע נוסף על מדיניות הפרטיות של קבוצת הראל בעניין השימוש במידע והגנה עליו, אשר חלה על השירות הניתן על-ידי הראל ועל השירות באתר לחץ כאן. 
         </p>
         <p>
            <strong>המידע באתר</strong>
          </p>
          <p>
             8. המידע שתמסור באמצעות האתר ישמש לצורך כל דבר ועניין הקשור במוצרי הביטוח, החיסכון הפנסיוני והפיננסים, אשר יש לך בקבוצת הראל, לרבות עיבודו, אחסונו ושימוש במידע וכן למטרות לגיטימיות אחרות לרבות למטרות עיבודים סטטיסטיים, ולמטרת שיפור ו/או שינוי השירותים הניתנים באמצעות האתר ותכניו, זאת אף באמצעות העברתו של המידע לצדדים שלישיים הפועלים בשמה ומטעמה של קבוצת הראל. 
          </p>
          <p>
             9. המידע שתמסור במסגרת המוצרים שברשותך, יימסר גם לסוכן הביטוח שלך באותם מוצרים. ייתכן והפרטים הנמסרים על-ידך בטופס הרישום לשירות המידע האישי יעודכנו במסגרת מוצרים שלך בקבוצת הראל. אם ברצונך להבטיח את עדכון הפרטים במוצרים שברשותך, עליך לעשות זאת באמצעות שירות עדכון פרטים באתר, באמצעות פנייה לשירות הלקוחות בהראל או באמצעות פניה לסוכן. 
          </p>
          <p>
              <strong>מניעת והפסקת שימוש באתר</strong>
            </p>
            <p>
               11. מבלי לגרוע מכל סעד העומד להראל על פי כל דין, הראל רשאית להפסיק לאלתר גישת משתמש, אשר פעל בניגוד לתנאי השימוש באתר, ללא כל הודעה מוקדמת. 
            </p>
            <p>
               12. בנוסף, חלק מן השירות הניתן ניתן מרצונה של הראל בלבד והיא רשאית להפסיקו בכל עת על פי שיקול דעתה הבלעדי וללא צורך במתן הודעה מוקדמת. 
            </p>
            <p>
              <strong>שינוי תנאי קבלת השירות באמצעות האתר </strong>
            </p>
            <p>
              13. הראל רשאית לשנות מעת לעת את תנאי השימוש באתר. בכל עת יופיעו באתר תנאי השימוש המעודכנים של הראל. שינויים כאמור יכנסו לתוקף עם פרסומם באתר והודעה על השינוי תוצג בעת כניסתו הבאה של המשתמש לאתר לאחר עדכונם של תנאי השימוש או בכל דרך אחרת שתבחר הראל. שימוש באתר לאחר קבלת ו/או פרסום ההודעה כאמור ייחשב להסכמה לכל השינויים, התנאים וההוראות שיחולו לגבי תנאי קבלת השירות. 
            </p>
            <p>
              <strong>כללי</strong>
            </p>
            <p>
              14. על הסכם זה יחולו חוקי מדינת ישראל.
             </p>
            <p>
               15. במידה וייקבע שחלק כלשהו מהסכם זה אינו תקף או שאינו ניתן לאכיפה, אזי הסעיפים שנשלל תוקפם או שאינם ניתנים לאכיפה ייחשבו כאילו הוחלפו בסעיפים תקפים וניתנים לאכיפה שתוכנם תואם במידת הקירוב הגדולה ביותר את כוונת הסעיפים המקוריים, ואילו יתר סעיפי ההסכם יישארו בתוקפם. 
            </p>
            <p>
              <strong>הוראות לקבלת שירות מידע אישי </strong>
            </p>
            <p>
               16. בהרשמתך הראשונה לאתר תתבקש לעבור תהליך זיהוי הכולל מענה לשאלות אישיות, אשר יכללו, בין היתר, שאלות לגבי המוצרים הקיימים לך בקבוצת הראל. 
            </p>
            <p>
               17. לאחר זיהוי מוצלח תקבל סיסמה חד פעמית למספר הטלפון הנייד שלך ותוכל להיכנס לצפות במידע האישי. 
            </p>
            <p>
               18. בכל כניסה שתבצע לאחר הכניסה הראשונית לאתר, תתבקש להזין את מספר תעודת הזהות שלך ומספר הטלפון הנייד שלך כפי שרשום במערכות החברה, ולאחר התאמה מלאה תקבל הודעת SMS אשר תכלול סיסמא חד פעמית. 
            </p>
            <p>
               19. במקרה שבו העמית או המבוטח הינו קטין או חסוי, בקשה זו תאושר על ידי אפוטרופסו ויראו את ההתחייבויות האמורות לעיל כהתחייבויותיו של אפוטרופסו לכל דבר ועניין. 
            </p>
            <p>
                  <strong>הסכמות לשימוש במידע והעברתו למטרות שיווקיות ולמשלוח פרסומות </strong>
            </p>
            <p>
                אם הסכמת בעבר לקבל פרסומות הסכמתך בתוקף ללא קשר לסימון למעלה. 
                בכל עת תוכל להודיע על סירובך לקבל הצעות שיווקיות והודעות פרסומיות בעיקרן כאמור באמצעות "טופס אי קבלת פרסומות והצעות שיווקיות" העומד לרשותך באתר האינטרנט של החברה בכתובת: <a href="https://www.harel-group.co.il/contact/Pages/refusal-to-accept-advertisement.aspx" target="_blank">https://www.harel-group.co.il/contact/Pages/refusal-to-accept-advertisement.aspx</a>  באמצעות פניה בכתב לכתובת: הראל חברה לביטוח בע"מ, בית הראל, רח' אבא הלל 3, ת.ד. 1951, רמת גן 5211802, או באמצעות פנייה טלפונית למספר 03-7547777. 
            </p>
            <p>
                בכל מקרה עדיין נוכל לשלוח לך פרסומות שמותר לנו לשלוח על-פי הדין למרות בחירתך, ונוכל גם לשלוח לך, בכל אמצעי קשר, הודעות בקשר לשירותים ולמוצרים שלך בקבוצת הראל, והודעות שאנחנו מחוייבים על-פי הדין לשלוח לך.
            </p>
        </div>
      </div>
      <div *ngIf="data?.showActivation" class="h-cl">
        <input type="checkbox" name="acceptActivation" id="acceptActivation" [(ngModel)]="statements.acceptActivation" checked>
        <label for="acceptActivation">
          אני מסכים לקבל פרסומות והצעות שיווקיות, לרבות בדיוור ישיר, מהגופים המוסדיים בקבוצת הראל בכל אמצעי הקשר שמסרתי לכם תוך שימוש
          במידע אודותיי שמצוי בידיכם והעברתו בין הגופיים המוסדיים
        </label>
      </div>
      <div *ngIf="data?.showSavingsMailing" class="h-cl">
        <input type="checkbox" name="acceptSavingsMailing" id="acceptSavingsMailing" [(ngModel)]="statements.acceptSavingsMailing"
          checked>
        <label for="acceptSavingsMailing">
          אני מסכים כי הדוח השנתי לעמית ישלח לדואר האלקטרוני שלי בכתובת שמסרתי לעיל וזאת במקום באמצעות הדואר
        </label>
      </div>
      <div *ngIf="data?.showHealthMailing" class="h-cl">
        <input type="checkbox" name="acceptHealthMailing" id="acceptHealthMailing" [(ngModel)]="statements.acceptHealthMailing" checked>
        <label for="acceptHealthMailing">
          אני מסכים כי כל הדיווחים השנתיים בביטוח בריאות שעלי לקבל מחברת הרא לחברה לביטוח בע״מ יישלחו לדואר האלקטרוני שלי בכתובת שמסרתי
          לעיל
        </label>
      </div>
    </div>
    <div class="right cb-special">
      <span>
        <input type="checkbox" name="acceptDecleration" id="acceptDecleration" [(ngModel)]="statements.acceptDecleration" ngModel aria-invalid="false"
          required #approve="ngModel">
        <label for="acceptDecleration">
          אני מסכים לתנאי השימוש באתר
          <a href="/terms-of-use/pages/privacy-policy.aspx" target="_blank">ולמדיניות הגנת הפרטיות</a>
          <br> ומקבל אותם על עצמי
        </label>
        <div hsgError *ngIf="approve?.errors?.required && activationForm.submitted">
          אני מסכים לתנאי השימוש
        </div>
      </span>
    </div>
  </div>
  <div class="actions actions-special">
    <button hsg-button kind="primary" (click)="activationForm.onSubmit()" [disabled]="pending">אשר והמשך
      <hsg-spinner *ngIf="pending" class="u-mr-s"></hsg-spinner>
    </button>
  </div>
</hsg-modal>